import { Blockquote } from "../components/Blockquote";
import { ContactSection } from "../components/ContactSection";
import { Container } from "../components/Container";
import { FadeIn } from "../components/FadeIn";
import { GridList, GridListItem } from "../components/GridList";
import { GridPattern } from "../components/GridPattern";
import { List, ListItem } from "../components/List";
import { PageIntro } from "../components/PageIntro";
import { SectionIntro } from "../components/SectionIntro";
import { StylizedImage } from "../components/StylizedImage";
import { TagList, TagListItem } from "../components/TagList";
import imageLaptop from "../images/laptop.jpg";
import imageMeeting from "../images/meeting.jpg";
import imageWhiteboard from "../images/whiteboard.jpg";

function Section({ title, image, children }) {
  return (
    <Container className="group/section [counter-increment:section]">
      <div className="lg:flex lg:items-center lg:justify-end lg:gap-x-8 lg:group-even/section:justify-start xl:gap-x-20">
        <div className="flex justify-center">
          <FadeIn className="w-[33.75rem] flex-none lg:w-[45rem]">
            <StylizedImage
              {...image}
              sizes="(min-width: 1024px) 41rem, 31rem"
              className="justify-center lg:justify-end lg:group-even/section:justify-start"
            />
          </FadeIn>
        </div>
        <div className="mt-12 lg:mt-0 lg:w-[37rem] lg:flex-none lg:group-even/section:order-first">
          <FadeIn>
            <div
              className="font-display text-base font-semibold before:text-neutral-300 before:content-['/_'] after:text-neutral-950 after:content-[counter(section,decimal-leading-zero)]"
              aria-hidden="true"
            />
            <h2 className="mt-2 font-display text-3xl font-medium tracking-tight text-neutral-950 sm:text-4xl">
              {title}
            </h2>
            <div className="mt-6">{children}</div>
          </FadeIn>
        </div>
      </div>
    </Container>
  );
}
function Culture() {
  return (
    <div className="mt-24 rounded-4xl dark-section bg-neutral-950 py-24 sm:mt-32 lg:mt-40 lg:py-32">
      <SectionIntro
        eyebrow=""
        title="Balance your passion with your passion for life."
        invert
      ></SectionIntro>
      <Container className="mt-16">
        <GridList>
          <GridListItem title="Loyalty" invert>
            Our team has been with us since the beginning because none of them
            are allowed to have LinkedIn profiles.
          </GridListItem>
          <GridListItem title="Trust" invert>
            We don’t care when our team works just as long as they are working
            every waking second.
          </GridListItem>
          <GridListItem title="Compassion" invert>
            You never know what someone is going through at home and we make
            sure to never find out.
          </GridListItem>
          <GridListItem title="Loyalty" invert>
            Our team has been with us since the beginning because none of them
            are allowed to have LinkedIn profiles.
          </GridListItem>
          <GridListItem title="Trust" invert>
            We don’t care when our team works just as long as they are working
            every waking second.
          </GridListItem>
          <GridListItem title="Compassion" invert>
            You never know what someone is going through at home and we make
            sure to never find out.
          </GridListItem>
          <GridListItem title="Loyalty" invert>
            Our team has been with us since the beginning because none of them
            are allowed to have LinkedIn profiles.
          </GridListItem>
          <GridListItem title="Trust" invert>
            We don’t care when our team works just as long as they are working
            every waking second.
          </GridListItem>
          <GridListItem title="Compassion" invert>
            You never know what someone is going through at home and we make
            sure to never find out.
          </GridListItem>
        </GridList>
      </Container>
    </div>
  );
}
function Discover() {
  return (
    <Section title="Discover" image={{ src: imageWhiteboard }}>
      <div className="space-y-6 text-base text-neutral-600">
        <p>
          We work closely with our clients to understand their{" "}
          <strong className="font-semibold text-neutral-950">needs</strong> and
          goals, embedding ourselves in their every day operations to understand
          what makes their business tick.
        </p>
        <p>
          Our team of private investigators shadow the company director’s for
          several weeks while our account managers focus on going through their
          trash. Our senior security experts then perform social engineering
          hacks to gain access to their{" "}
          <strong className="font-semibold text-neutral-950">business</strong>{" "}
          accounts — handing that information over to our forensic accounting
          team.
        </p>
        <p>
          Once the full audit is complete, we report back with a comprehensive{" "}
          <strong className="font-semibold text-neutral-950">plan</strong> and,
          more importantly, a budget.
        </p>
      </div>

      <h3 className="mt-12 font-display text-base font-semibold text-neutral-950">
        Included in this phase
      </h3>
      <TagList className="mt-4">
        <TagListItem>In-depth questionnaires</TagListItem>
        <TagListItem>Feasibility studies</TagListItem>
        <TagListItem>Blood samples</TagListItem>
        <TagListItem>Employee surveys</TagListItem>
        <TagListItem>Proofs-of-concept</TagListItem>
        <TagListItem>Forensic audit</TagListItem>
      </TagList>
    </Section>
  );
}

function Build() {
  return (
    <Section title="Build" image={{ src: imageLaptop, shape: 1 }}>
      <div className="space-y-6 text-base text-neutral-600">
        <p>
          Based off of the discovery phase, we develop a comprehensive roadmap
          for each product and start working towards delivery. The roadmap is an
          intricately tangled mess of technical nonsense designed to drag the
          project out as long as possible.
        </p>
        <p>
          Each client is assigned a key account manager to keep lines of
          communication open and obscure the actual progress of the project.
          They act as a buffer between the client’s incessant nagging and the
          development team who are hard at work scouring open source projects
          for code to re-purpose.
        </p>
        <p>
          Our account managers are trained to only reply to client emails after
          9pm, several days after the initial email. This reinforces the general
          aura that we are very busy and dissuades clients from asking for
          changes.
        </p>
      </div>

      <Blockquote
        author={{ name: "Debra Fiscal", role: "CEO of Unseal" }}
        className="mt-12"
      >
        Studio were so regular with their progress updates we almost began to
        think they were automated!
      </Blockquote>
    </Section>
  );
}

function Deliver() {
  return (
    <Section title="Deliver" image={{ src: imageMeeting, shape: 2 }}>
      <div className="space-y-6 text-base text-neutral-600">
        <p>
          About halfway through the Build phase, we push each project out by 6
          weeks due to a change in{" "}
          <strong className="font-semibold text-neutral-950">
            requirements
          </strong>
          . This allows us to increase the budget a final time before launch.
        </p>
        <p>
          Despite largely using pre-built components, most of the{" "}
          <strong className="font-semibold text-neutral-950">progress</strong>{" "}
          on each project takes place in the final 24 hours. The development
          time allocated to each client is actually spent making augmented
          reality demos that go viral on social media.
        </p>
        <p>
          We ensure that the main pages of the site are{" "}
          <strong className="font-semibold text-neutral-950">
            fully functional
          </strong>{" "}
          at launch — the auxiliary pages will, of course, be lorem ipusm shells
          which get updated as part of our exorbitant{" "}
          <strong className="font-semibold text-neutral-950">
            maintenance
          </strong>{" "}
          retainer.
        </p>
      </div>

      <h3 className="mt-12 font-display text-base font-semibold text-neutral-950">
        Included in this phase
      </h3>
      <List className="mt-8">
        <ListItem title="Testing">
          Our projects always have 100% test coverage, which would be impressive
          if our tests weren’t as porous as a sieve.
        </ListItem>
        <ListItem title="Infrastructure">
          To ensure reliability we only use the best Digital Ocean droplets that
          $4 a month can buy.
        </ListItem>
        <ListItem title="Support">
          Because we hold the API keys for every critical service your business
          uses, you can expect a lifetime of support, and invoices, from us.
        </ListItem>
      </List>
    </Section>
  );
}

function Values() {
  return (
    <div className="relative mt-0 pt-20 sm:mt-0 sm:pt-32 lg:mt-0 lg:pt-40">
      <SectionIntro
        eyebrow="Our abilities"
        title=" We create products that is both functional and beautiful."
      >
        <p>
          We see ourselves as a team of designers, engineers, and developers
          obsessed with creating the best products possible.
        </p>
      </SectionIntro>

      <Container className="mt-24">
        <GridList>
          <GridListItem title="AI and Machine Learning">
            We leverage AI and machine learning technologies to build
            intelligent systems that drive innovation.
          </GridListItem>
          <GridListItem title="Data Analytics">
            We provide data analytics services to help businesses make informed
            decisions based on actionable insights.
          </GridListItem>
          <GridListItem title="IoT">
            We develop Internet of Things (IoT) applications that connect
            devices and systems for smarter operations.
          </GridListItem>
          <GridListItem title="Cloud">
            We offer scalable and secure cloud solutions to help businesses
            manage their data and applications efficiently.
          </GridListItem>
          <GridListItem title="Development">
            We create tailored software solutions that meet the unique needs of
            our clients.
          </GridListItem>
          <GridListItem title="Web Development">
            Our team builds responsive and user-friendly websites that provide
            an exceptional user experience.
          </GridListItem>
          <GridListItem title="Mobile App Development">
            We develop high-performance mobile applications for both iOS and
            Android platforms.
          </GridListItem>
          <GridListItem title="UI/UX Design">
            Our designers create intuitive and visually appealing interfaces
            that enhance user engagement.
          </GridListItem>
          <GridListItem title="API Development">
            We design and implement robust APIs that enable seamless integration
            between different systems.
          </GridListItem>
          <GridListItem title="Legacy System Modernization">
            We help businesses upgrade and modernize their legacy systems to
            improve
          </GridListItem>
          <GridListItem title="Quality Assurance">
            Our QA team ensures that all products meet the highest standards of
            quality and reliability.
          </GridListItem>
          <GridListItem title="Technical Support">
            Our dedicated support team is available to assist with any technical
            issues and ensure smooth operations.
          </GridListItem>
          <GridListItem title="Consulting Services">
            We offer strategic consulting services to help businesses navigate
            complex technological challenges.
          </GridListItem>
          <GridListItem title="Embedded Systems">
            We design and develop embedded systems for various applications,
            ensuring high performance and reliability.
          </GridListItem>
          <GridListItem title="Hardware Prototyping">
            We create hardware prototypes to test and validate new product
            concepts quickly and efficiently.
          </GridListItem>
          <GridListItem title="Hardware Testing and Validation">
            We perform rigorous testing and validation of hardware components to
            ensure they meet the highest standards.
          </GridListItem>
          <GridListItem title="Robotics">
            We design and build robotic systems for industrial automation,
            healthcare, and other applications.
          </GridListItem>
          <GridListItem title="Sensor Integration">
            We integrate various sensors into systems to collect and process
            real-time data for improved decision-making.
          </GridListItem>
        </GridList>
      </Container>
    </div>
  );
}

export const metadata = {
  title: "Our Process",
  description:
    "We believe in efficiency and maximizing our resources to provide the best value to our clients.",
};

export default function Process() {
  window.scrollTo(0, 0);
  return (
    <>
      {/* <PageIntro eyebrow="Our process" title="How we work">
        <p>
          We believe in efficiency and maximizing our resources to provide the
          best value to our clients. The primary way we do that is by re-using
          the same five projects we’ve been developing for the past decade.
        </p>
      </PageIntro> */}

      {/* <div className="mt-24 space-y-24 [counter-reset:section] sm:mt-32 sm:space-y-32 lg:mt-40 lg:space-y-40">
        <Discover />
        <Build />
        <Deliver />
      </div> */}

      <Values />
      {/* <Culture /> */}

      <ContactSection />
    </>
  );
}
